import { injectable } from "inversify";
import CarPeritajeReportEntity from "../../../../domain/entities/CarPeritajeReportEntity";
import CarPeritajeReportRepository from "../../../../domain/repositories/CarPeritajeReportRepository";
import GetActiveCarsPeritajeReportApiImpl from "./api/GetActiveCarsPeritajeReportApiImpl";

@injectable()
export default class CarPeritajeReportRepositoryImpl implements CarPeritajeReportRepository {
    getActiveCarsPeritajeReport = (
        onProgress?: (done: number, total: number) => void,
    ): Promise<CarPeritajeReportEntity[]> => GetActiveCarsPeritajeReportApiImpl(onProgress);
}
